import React, { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classnames from "classnames";

import styles from "./styles.module.scss";

export type RadioButtonGroupType = HtmlHTMLAttributes<HTMLDivElement>

export const RadioButtonGroup = memo(forwardRef<HTMLDivElement, RadioButtonGroupType>((
  {
    className,
    children,
    ...props
  }, ref) =>
  <div
    ref={ref}
    {...props}
    className={classnames(
      className,
      styles.root,
    )}
  >
    {children}
  </div>,
));